export class Notification {
    public static RETURN_ֹNOTIFICATION = 'return';
    public static APPROVED_NOTIFICATION = 'approve';
    public static CONTACT_THE_RESERACHER_NOTIFICATION = 'contact';
}
